import React, { useEffect, useRef, useState } from "react";
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/owl.carousel.min.css";
import { globalLoader } from "../../../helpers/global";
import videoImage from "../orderTracking/img-tracking/video.mp4";
// import iconImage1 from "../orderTracking/img-tracking/icon-1.svg";
// import iconImage2 from "../orderTracking/img-tracking/icon-2.svg";
import orderInKitchenImage from "../orderTracking/img-tracking/order-in-kitchen-image.gif";
import orderReadyImage from "../orderTracking/img-tracking/order-ready-image.gif";
import { useParams, useSearchParams } from "react-router-dom";
import { GetTrackingOrders } from "../../../services/orderTracking/orderTrackingService";
import { SOCKET_CLIENT } from "../../../utils/socket";
import { ORDER_STATUS, SOCKET_EVENTS } from "../../../utils/Constants";
import { GetBrandFromOutletId } from "../../../services/company_panel/brandService"
import Swal from "sweetalert2";

const OrderTracking = () => {
  const [searchParams] = useSearchParams();
  const [brandVideo, setBrandVideo] = useState(null);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [readyOrders, setReadyOrders] = useState([]);
  const videoRef = useRef(null);

 
  //Socket join event
  useEffect(()=>{
    const company_id = searchParams.get("company_id");
    const outlet_id = searchParams.get("outlet_id");
    const roomId = `${company_id}-${outlet_id}`;
    let joinRequest = {
      roomID : roomId
    };
    SOCKET_CLIENT.emit('JOIN-USER', joinRequest, (error) => {
      if (error) {
        console.error("*****Socket connection error on JOIN-USER", error);
      }
      else{
          console.log("joined")
      }
    });
  }, [searchParams]); 
  
  //Socket listen events
  useEffect(() => {
   
    const handleSocketResponse = (response) => {
      const data = response?.data;
      console.log('Socket response received:', response);

      if (response?.event === SOCKET_EVENTS.ORDER_CREATED) {
          if(!data?.order_status || data?.order_status=='pending')return;

          Swal.fire({
              customClass: 'swal-wide',
              icon: 'success',
              title: response?.message,
              showConfirmButton: false,
              timer: 5000,
              toast: true,
              position: 'top-right',
          })
        
          setPendingOrders(prev => [
            {
              order_id: data?.order_id,
              order_status: data?.order_status,
              aggregator_id: data?.aggregator_id,
              aggregator_logo: data?.aggregator_logo,
              order_mode_logo: data?.order_mode_logo,
            },
            ...prev,
          ]);
      }else if(response?.event === SOCKET_EVENTS.ORDER_UPDATED) {
          if(!(data?.update_type== "recall-order" || data?.update_type== "checkout-order"))return;
          if(!data?.order_status || data?.order_status=='pending')return;
          
          Swal.fire({
              customClass: 'swal-wide',
              icon: 'success',
              title: response?.message,
              showConfirmButton: false,
              timer: 5000,
              toast: true,
              position: 'top-right',
          })
        
          setPendingOrders(prev => [
            {
              order_id: data?.order_id,
              order_status: data?.order_status,
              aggregator_id: data?.aggregator_id,
              aggregator_logo: data?.aggregator_logo,
              order_mode_logo: data?.order_mode_logo,
            },
            ...prev,
          ]);
      }else if(response?.event === SOCKET_EVENTS.ORDER_MARKED_READY){       
        Swal.fire({
          customClass: 'swal-wide',
          icon: 'success',
          title: response?.message,
          showConfirmButton: false,
          timer: 5000,
          toast: true,
          position: 'top-right',
        })
        setPendingOrders(prevPendingOrders =>{
          const oldPendingOrders = [...prevPendingOrders];
          const orderIndex = oldPendingOrders.findIndex(order => order.order_id == data?.order_id);
          if(orderIndex == -1)return oldPendingOrders;

          const [order] = oldPendingOrders.splice(orderIndex, 1);
          order.order_status = data?.order_status;
          setReadyOrders(prevReadyOrders => [order, ...prevReadyOrders]);
          return oldPendingOrders;
        })
      }else if(response?.event === SOCKET_EVENTS.ORDER_MARKED_CLOSE){       
        Swal.fire({
          customClass: 'swal-wide',
          icon: 'success',
          title: response?.message,
          showConfirmButton: false,
          timer: 5000,
          toast: true,
          position: 'top-right',
        })
        setReadyOrders(prevReadyOrders =>{
          const oldReadyOrders = [...prevReadyOrders];
          const orderIndex = oldReadyOrders.findIndex(order => order.order_id == data?.order_id);
          if(orderIndex == -1)return oldReadyOrders;

          oldReadyOrders.splice(orderIndex, 1);
          return oldReadyOrders;
        })
        setPendingOrders(prevPendingOrders =>{
          const oldPendingOrders = [...prevPendingOrders];
          const orderIndex = oldPendingOrders.findIndex(order => order.order_id == data?.order_id);
          if(orderIndex == -1)return oldPendingOrders;
          
          oldPendingOrders.splice(orderIndex, 1);
          return oldPendingOrders;
        })
      }    
      
    };
    
    SOCKET_CLIENT.on('GET-DATA', handleSocketResponse);
  
    return () => {
      SOCKET_CLIENT.off('GET-DATA', handleSocketResponse);
    };
  }, []); 
  
  //orders get API
  useEffect(() => {
    globalLoader(false);

    const company_id = searchParams.get("company_id");
    const outlet_id = searchParams.get("outlet_id");
    GetTrackingOrders({ company_id, outlet_id })
      .then((response) => {
        const orders = response.data.response;
        const pendingOrders = [];
        const readyOrders = [];
        orders.forEach(order =>{
          if(order.order_status == 'ready'){
            readyOrders.push(order);
          }else{
            pendingOrders.push(order);
          }
        })
        setPendingOrders(pendingOrders);
        setReadyOrders(readyOrders);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //getting brand video
  useEffect(() => {
    globalLoader(false);

    const company_id = searchParams.get("company_id");
    const outlet_id = searchParams.get("outlet_id");
    GetBrandFromOutletId({ company_id, outlet_id })
      .then((response) => {
        console.log('-------resposse', response);
        if(!response?.data?.success){
           Swal.fire({
              customClass: 'swal-wide',
              icon: 'error',
              title: response?.data?.message,
              showConfirmButton: false,
              timer: 5000,
              toast: true,
              position: 'top-right',
          })
        }else{
          setBrandVideo(response.data.response.brand.video);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [searchParams]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }

    return ()=>{
      videoRef.current = null
    }
  }, []);

  
  return (
    <div className="order-tracking-view">
      {/* <div className="row m-0"> */}
      <div className="row m-0" style={{ height: '100vh', overflow: 'hidden' }}>
        {/* Brand Video */}
        <div className="col-md-4 p-0">
          {/* <div className="video-tracking" style={{ height: '100vh', overflow: 'hidden' }}> */}
          <div className="video-tracking" style={{ height: '100%', overflow: 'hidden' }}>  
            <video
              // ref={videoRef}
              // src={videoImage}
              src={brandVideo ? brandVideo : videoImage }
              muted
              autoPlay
              loop
              // controls
              style={{ 
                width: '100%', 
                height: '100vh', // Set this explicitly
                objectFit: 'cover', //
              }}
            >
              Your browser does not support the video tag.
            </video>
            {/* <img src=""></img> */}
          </div>
        </div>

        {/* Order Kitchen Section */}
        <div className="col-md-4 p-0">
          <div className="order-info-card">
            <div className="order-info-card-in">
              
              <div className="order-info-card-head d-flex justify-content-center align-items-center gap-5">
                {/* <figure> */}
                  <img src={orderInKitchenImage} style={{height : '100px', borderRadius : '20px'}} alt="order-info-card-img" />
                  <div>
                    <h2 className="text-center mt-3 text-white" style={{fontSize : '30px', fontWeight : 'normal'}}>جاري التحضير</h2>
                    <h2 className="text-center mt-3 text-white" style={{fontSize : '30px', fontWeight : 'normal'}}>In Kitchen</h2>
                  </div>
                  
                {/* </figure> */}
              </div>
                
              <div className="order-info-card-list">
              <ul style={{
                display: 'flex',
                flexWrap: 'wrap',
                listStyle: 'none',
                padding: 0,
                margin: 0,
                gap: '16px',
                justifyContent: 'flex-between',
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',     // 👈 enables vertical scroll
                overflowX: 'hidden'
              }}>
                {pendingOrders
                  // .filter((order) => order.order_status === "pending")
                  .map((order, index) => (
                    <li
                      key={index}
                      style={{
                        flex: '1 1 calc(50% - 8px)', // Two columns with gap accounted
                        boxSizing: 'border-box',
                        padding: '12px',
                        borderRadius: '8px',
                        // justifyContent: 'flex-start',
                      }}
                    >
                      <figure>
                        <img
                          src={order.aggregator_id
                            ? order.aggregator_logo
                            : order.order_mode_logo}
                          alt="order-info-card-img"
                          style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
                        />
                      </figure>
                      <div className="order-info-card-list-text text-2xl">
                        <h3 className="text-white" style={{fontSize : '30px', fontWeight : 'normal'}}>{order?.order_id}</h3>
                      </div>
                    </li>
                  ))}
              </ul>

                {/* <ul>
                  {orders
                    .filter((order) => order.order_status == "pending")
                    .map((order) => (
                      <li>
                        <figure>
                          <img
                            // src="https://as1.ftcdn.net/jpg/02/86/12/22/1000_F_286122238_zWzctXPgodrwNOnkBXpjzuO8NeS0T0oJ.jpg"
                            src = { order.aggregators_configuration ? order.order_mode_configuration.logo : order.order_mode_configuration.logo }
                            alt="order-info-card-img"
                          />
                        </figure>
                        <div className="order-info-card-list-text">
                          <h3 className="text-white">{order?.id}</h3>
                        </div>
                      </li>
                    ))}
                </ul> */}
              </div>
            </div>
          </div>
        </div>

        {/* Order Ready Section */}
        <div className="col-md-4 p-0">
          <div className="order-info-card">
            <div className="order-info-card-in">
              <div className="order-info-card-head">
                <div className="order-info-card-head d-flex justify-content-center align-items-center gap-5">
                {/* <figure> */}
                  <img src={orderReadyImage} style={{height : '100px', borderRadius : '20px'}} alt="order-info-card-img" />
                  <div>
                    <h2 className="text-center mt-3 text-white" style={{fontSize : '30px', fontWeight : 'normal'}}> جاهز للاستلام </h2>
                    <h2 className="text-center mt-3 text-white" style={{fontSize : '30px', fontWeight : 'normal'}}>Order Ready</h2>
                  </div>
                  
                {/* </figure> */}
                </div>
              </div>
              <div className="order-info-card-list">
              <ul style={{
                display: 'flex',
                flexWrap: 'wrap',
                listStyle: 'none',
                padding: 0,
                margin: 0,
                gap: '16px',
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',     // 👈 enables vertical scroll
                overflowX: 'hidden'
              }}>
                {readyOrders
                  // .filter((order) => order.order_status === "ready")
                  .map((order, index) => (
                    <li
                      key={index}
                      style={{
                        flex: '1 1 calc(50% - 8px)', // Two columns with gap accounted
                        boxSizing: 'border-box',
                        padding: '12px',
                        borderRadius: '8px',
                        justifyContent: 'flex-between',
                      }}
                    >
                      <figure>
                        <img
                          src={order.aggregator_id
                            ? order.aggregator_logo
                            : order.order_mode_logo}
                          alt="order-info-card-img"
                          style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
                        />
                      </figure>
                      <div className="order-info-card-list-text">
                        <h3 className="text-white" style={{fontSize : '30px', fontWeight : 'normal'}}>{order?.order_id}</h3>
                      </div>
                    </li>
                  ))}
              </ul>

                {/* <ul>
                  {orders
                    .filter((order) => order.order_status == "ready")
                    .map((order) => (
                      <li style={{backgroundColor : 'blue'}}>
                        <figure>
                          <img
                            // src="https://as1.ftcdn.net/jpg/02/86/12/22/1000_F_286122238_zWzctXPgodrwNOnkBXpjzuO8NeS0T0oJ.jpg"
                            src = { order.aggregators_configuration ? order.order_mode_configuration.logo : order.order_mode_configuration.logo }
                            alt="order-info-card-img"
                          />
                        </figure>
                        <div className="order-info-card-list-text">
                          <h3 className="text-white">{order?.id}</h3>
                        </div>
                      </li>
                    ))}
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTracking;
